import {IProductDetails} from "@/types/product.types";
import React from "react";
import {Swiper, SwiperSlide} from "swiper/react";
import ProductCard from "../ProductCard";

const ProductRecommend: React.FC<{data: IProductDetails}> = ({data}) => {
  const hasRecommended = data?.for_yous && data?.for_yous.length ? true : false;

  if (!hasRecommended) {
    return <React.Fragment />;
  }

  return (
    <section className="mt-9 lg:mt-14">
      <h2 className="font-medium uppercase ">you may also like</h2>
      <div className="mt-2 overflow-hidden">
        <Swiper
          draggable
          breakpoints={{
            "0": {
              slidesPerView: 2,
              spaceBetween: 18,
            },
            "768": {
              slidesPerView: 2,
              spaceBetween: 50,
            },
          }}
          className="mt-3 "
        >
          {data?.for_yous?.map((product, i) => (
            <SwiperSlide className="cursor-pointer" key={i * 24}>
              <ProductCard data={product} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default ProductRecommend;
